import Axios from "axios";
import { host } from '../../inv';

export const createPost = (data, callback) => {
  Axios.post(host + "/post/create", data).then(res =>
    callback(res.data)
  );
};

export const getPostByPostId = (id, callback) => {
  Axios.get(host + "/post/getpostbypostid/" + id).then(res =>
    callback(res.data)
  );
};

export const updatePost = (data, callback) => {
  Axios.post(host + "/post/update", data).then(res =>
    callback(res.data)
  );
};

export const deletePostById = (postId, callback) => {
  Axios.post(host + "/post/deletepostbyid/", postId).then(res =>
    callback(res)
  );
};